import { Phone } from "lucide-react";

export default function StickyMobileCTA({ content }) {
  const tel = content.phone.replace(/[^+\d]/g, "");
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 p-3 bg-neutral-950/95 backdrop-blur border-t border-neutral-800" data-testid="sticky-mobile-cta">
      <a
        href={`tel:${tel}`}
        className="w-full flex items-center justify-center gap-3 bg-orange-600 hover:bg-orange-700 text-white font-display font-bold uppercase tracking-wider py-4 text-base"
        data-testid="sticky-call-btn"
      >
        <Phone className="w-5 h-5" />
        Call {content.phone}
      </a>
    </div>
  );
}
